import { IonButtons, IonButton, IonHeader, IonToolbar, IonModal, IonIcon } from '@ionic/react';
import React from 'react';
import '../Page.css';
import OnboardingSteps from './OnboardingSteps';
/* Pullstate Store */
import { UserStore } from "../../store/UserStore";
import { chevronBackOutline, closeOutline } from 'ionicons/icons';

const OnboardingModal = () => {
    const step = UserStore.useState(s => s.onboardingStep);

    const close = () => {
        UserStore.update(s => {
            s.onboardingModal = false;
        })
    }
    const updateStep = (inc) => {
        if(inc !== 0) {
            UserStore.update(s => {
                s.onboardingStep = s.onboardingStep + inc;
            })
        } else {
            UserStore.update(s => {
                s.onboardingStep = 0;
            })
        }
    }

    return (
        <IonModal 
            isOpen={step > 0}
            onDidDismiss={close}
            mode="ios"
        >
            <IonHeader>
                <IonToolbar>
                    {step > 1 ? 
                    <IonButtons>
                        <IonButton onClick={() => updateStep(-1)}><IonIcon icon={chevronBackOutline} slot="start"/>Back</IonButton>
                    </IonButtons>
                    : null}
                    <IonButtons slot="end">
                        <IonButton 
                            onClick={() => {
                                updateStep(0);
                                close();
                            }}
                        ><IonIcon icon={closeOutline} slot="icon-only"/></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <OnboardingSteps />
        </IonModal>
  );
};

export default OnboardingModal;
